type AccountLink = {
  name: string;
  link: string;
  uid: string;
};

type AccountLinks = {
  en: AccountLink[];
  fr: AccountLink[];
};

const accountLinksEn: AccountLink[] = [
  {
    name: 'Account Settings',
    link: '/my-account',
    uid: 'AccountLinksSection',
  },
  {
    name: 'PC Optimum',
    link: '/my-account/optimum',
    uid: 'ShoppersOptimumRewardsLink',
  },
  {
    name: 'Order History',
    link: '/my-account/orders',
    uid: 'OrderHistoryLink',
  },
  {
    name: 'Shipping Information',
    link: '/my-account/address-book',
    uid: 'AddressesLink',
  },
  {
    name: 'Payment Information',
    link: '/my-account/payment-details',
    uid: 'PaymentInfoLink',
  },
  {
    name: 'Favourites',
    link: '/favourite',
    uid: 'FavouritesLink',
  },
  {
    name: 'Log Out',
    link: '/logout',
    uid: 'SignOutLink',
  },
];

const accountLinksFr: AccountLink[] = [
  {
    name: 'Paramètres Du Compte',
    link: '/my-account',
    uid: 'AccountLinksSection',
  },
  {
    name: 'Récompenses Pharmaprix Optimum',
    link: '/my-account/optimum',
    uid: 'ShoppersOptimumRewardsLink',
  },
  {
    name: 'Historique Des Commandes',
    link: '/my-account/orders',
    uid: 'OrderHistoryLink',
  },
  {
    name: 'Adresse De Livraison',
    link: '/my-account/address-book',
    uid: 'AddressesLink',
  },
  {
    name: 'Renseignements sur le paiement',
    link: '/my-account/payment-details',
    uid: 'PaymentInfoLink',
  },
  {
    name: 'Mes Favoris',
    link: '/favourite',
    uid: 'FavouritesLink',
  },
  {
    name: 'Fermer la session',
    link: '/logout',
    uid: 'SignOutLink',
  },
];

export const accountLinksNav: AccountLinks = {
  en: accountLinksEn,
  fr: accountLinksFr,
};
